const normalizeCreatorLocation = (rawLocation?: string | null) => {
  if (!rawLocation) return "";

  const locationParts = rawLocation
    .split(",")
    .map((part) => part.trim())
    .filter(Boolean);

  return locationParts.length > 3
    ? locationParts.slice(-3).join(", ")
    : locationParts.join(", ");
};

export const getCreatorsListUrl = (defaultLocation?: string | null) => {
  const params = new URLSearchParams();
  const normalizedDefaultLocation = normalizeCreatorLocation(defaultLocation);
  if (normalizedDefaultLocation) {
    params.set("locations", normalizedDefaultLocation);
  }

  const finalQuery = params.toString();
  return finalQuery ? `/creators?${finalQuery}` : "/creators";
};
